<style lang="stylus">
.profile-header {
  top: 57px;
  background: #fec528;
  font-size: 20px;
}
</style>
<template>
  <div style="position: relative">
    <img src="/img/profile_hero.svg" height="70" width="100%" style="object-fit: cover; background: #e8e8e8" alt="" />
    <v-container class="container">
      <v-row class="profile-hero-section d-flex align-center">
        <v-col cols="6" sm="4" md="4" lg="2" xl="2">
          <span class="font-weight-black px-1 profile-header">My Profile</span>
        </v-col>
        <v-spacer />
        <v-col cols="2" sm="3" md="2" lg="2" xl="2">
          <v-btn
            v-if="hasAsurite"
            rounded
            variant="outlined"
            style="border: 3px solid #fec528; background: #fec528 !important"
            color="#000000"
            class="px-6 hover-button"
            :class="{ 'd-none': $vuetify.display.xs }"
            @click="editProfile"
          >
            <v-icon
              style="font-size: 15px"
              class="pr-2 font-weight-black fal fa-regular fa-pen theme--dark"
              color="#000000"
            />
            <span style="font-size: 16px">Edit Profile</span>
          </v-btn>
          <v-btn
            v-if="hasAsurite"
            icon
            variant="outlined"
            style="border-color: #fec528; background: #fec528 !important"
            color="#000000"
            size="small"
            :class="{ 'd-none': $vuetify.display.smAndUp }"
            @click="editProfile"
          >
            <v-icon small class="pl-1 font-weight-black" color="#000000">mdi-pen</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['editProfile'],
  name: 'ProfileHero',

  props: {
    hasAsurite: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    editProfile() {
      this.$emit('editProfile');
    }
  }
});
</script>

<style lang="stylus" scoped>
.profile-hero-section {
  position: absolute;
  top: 44px;

  @media (min-width: 1441px) {
    width: 68%;
  }

  @media (max-width: 1440px) {
    width: 78%;
  }

  @media (max-width: 1024px) {
    width: 82%;
  }

  @media (max-width: 768px) {
    width: 97%;
  }

  @media (max-width: 425px) {
    width: 94%;
  }
}

.hover-button:hover {
  border: 3px solid rgb(254, 204, 77) !important;
  background: #fec528 !important;
}
</style>
